import React from "react";
import dayjs from "dayjs";
import { useState, useEffect } from "react";

const CountdownUnit = ({ digits, name, extend }) => {
  return (
    <div
      className={`countdown-unit${
        extend && " d-lg-flex align-items-lg-center"
      }`}
    >
      <div className="countdown-unit__numbers">
        <div className="countdown-unit__number">
          <span className={`${extend ? "heading-lg text-bold" : "heading-sm"}`}>
            {digits.charAt(0)}
          </span>
        </div>
        <div className="countdown-unit__number">
          <span className={`${extend ? "heading-lg text-bold" : "heading-sm"}`}>
            {digits.charAt(1)}
          </span>
        </div>
      </div>
      <div
        className={`countdown-unit__name${
          extend && " text-bold text-uppercase"
        }`}
      >
        {name}
      </div>
    </div>
  );
};

const CountdownOfferta = ({ date, extend }) => {
  const [days, setDays] = useState("--");
  const [hours, setHours] = useState("--");
  const [minutes, setMinutes] = useState("--");

  useEffect(() => {
    const interval = setInterval(() => {
      const diffMins = dayjs(date).diff(dayjs(), "minutes");
      const days = Math.floor(diffMins / (24 * 60));
      setDays(("0" + days).slice(-2));
      const rest = diffMins - days * (24 * 60);
      const hours = Math.floor(rest / 60);
      setHours(("0" + hours).slice(-2));
      setMinutes(("0" + (rest - hours * 60)).slice(-2));
    }, 1000);
    return () => clearInterval(interval);
  }, [date]);

  return days === "--" ? null : (
    <div
      className={`countdown-offerta${extend && " countdown-offerta--extend"}`}
    >
      <div className="countdown-offerta__timer" role="timer">
        <CountdownUnit
          digits={days}
          extend={extend}
          name={days === "01" ? "Giorno" : "Giorni"}
        />
        <CountdownUnit
          digits={hours}
          extend={extend}
          name={hours === "01" ? "Ora" : "Ore"}
        />
        <CountdownUnit
          digits={minutes}
          extend={extend}
          name={minutes === "01" ? "Minuto" : "Minuti"}
        />
      </div>
    </div>
  );
};

export default CountdownOfferta;
